import React, { useCallback, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { observer } from 'mobx-react';
import { load } from 'recaptcha-v3';

import { InsuranceFormComponent } from './InsuranceFormComponent';
import InsuranceStore from '../../stores/InsuranceStore';
import UserStore from '../../stores/UserStore';
import { Suspended } from '../../hocs/withLoadingFallback';
import { Result } from './Result';

const validationSchema = Yup.object().shape({
  firstname: Yup.string()
    .trim()
    .required('Ce champ est obligatoire.'),
  lastname: Yup.string()
    .trim()
    .required('Ce champ est obligatoire.'),
  phone: Yup.string().required('Ce champ est obligatoire.'),
  email: Yup.string()
    .trim('Ce champ ne peut pas inclure d\'espace au début et à la fin')
    .strict(true)
    .email('Merci de renseigner une adresse email valide.')
    .required('Ce champ est obligatoire.'),
  message: Yup.string()
    .trim()
    .required('Ce champ est obligatoire.'),
});

const InsuranceFormContainer = observer(() => {
  const { isSent, isFailed } = InsuranceStore;
  const { userProInfo, isUserBusy } = UserStore;
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const getRecaptchaToken = useCallback(async () => {
    const recaptcha = await load(process.env.GOOGLE_RECAPTCHA_SITE_KEY);
    const token = await recaptcha.execute('insurance_request_creation');

    if (token) {
      setRecaptchaToken(token);
    }
  }, []);

  useEffect(() => {
    UserStore.getProUser();
  }, []);

  useEffect(() => {
    getRecaptchaToken();
  }, []);

  const onSubmit = (values, { setErrors }) => {
    const payload = {
      insurance_request: {
        ...values,
        new_google_recaptcha_token: recaptchaToken,
      },
    };
    InsuranceStore.sendInsuranceRequest(payload, setErrors);
  };

  const initialValues = {
    firstname: userProInfo?.firstname || '',
    lastname: userProInfo?.lastname || '',
    phone: userProInfo?.phone || '',
    email: userProInfo?.email || '',
    message: '',
  };

  return (
    <Suspended isLoading={isUserBusy}>
      {
        isSent || isFailed
          ? <Result isSuccess={isSent} />
          : <InsuranceFormComponent initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} userInfo={userProInfo} />
      }
    </Suspended>
  );
});

export { InsuranceFormContainer };
